export const IntegrationServiceTypes = {
  SERVICE_LEDGER: 'ledger',
};

export const IntegrationSyncingStatusTypes = {
  AUTO_SYNC: 'auto_sync',
  MANUAL_SYNC: 'manual_sync',
  NO: 'no',
};

export const NETSUITE = 'NetSuite';
export const QBO = 'QuickBooks Online';
export const SAGE_INTACCT = 'Sage Intacct';
export const XERO = 'Xero';
